FD.LocalStorage = (function ($, me) {
    'use strict';

    me.LocalStorage = me.LocalStorage || {};

    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */

    const storageIsSupported = checkLocalStorageIsSupported();


    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */


    function checkLocalStorageIsSupported() {
        const test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (error) {
            return false;
        }
    }


    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */


    me.LocalStorage.set = function (key, value) {
        if (storageIsSupported) {
            localStorage.setItem(key, value);
        }
    };


    me.LocalStorage.get = function (key) {
        return storageIsSupported ? localStorage.getItem(key) : null;
    };


    me.LocalStorage.remove = function (key) {
        if (storageIsSupported) {
            localStorage.removeItem(key);
        }
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return me.LocalStorage;
}(jQuery, FD));